import type { PropsWithChildren, FC } from 'react'
import React from 'react'

import { TUBE_ITEM_HEIGHT } from '../utils/weekLayoutConstants'

type Props = {
  maxOffsetY: number
  children?: React.ReactNode
}

const WeekRestAutosizer: FC<PropsWithChildren<Props>> = React.memo(
  ({ children, maxOffsetY }) => {
    const stackedCount = maxOffsetY + 1
    const height = stackedCount * TUBE_ITEM_HEIGHT

    return <div style={{ height }}>{children}</div>
  }
)

export default WeekRestAutosizer
